import React from 'react';
import graphql from 'graphql';
import styled from 'styled-components';
import HTMLtoJSX from '../components/HTMLtoJSX';
import {
  PageWrapper,
  Heading,
  Paragraph,
  mediaQueries,
  Measures,
  spacing,
  fonts,
  fontSizes,
  colors
} from '../components/Styling';

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

class TextArea extends React.Component {
  constructor(props) {
    super(props);
    this.autoresize = this.autoresize.bind(this);
  }

  autoresize() {
    this.textarea.style.height = 'auto';
    this.textarea.style.height = this.textarea.scrollHeight + 'px';

    this.textarea.scrollTop = this.textarea.scrollHeight;
    window.scrollTo(window.scrollLeft, this.textarea.scrollTop + this.textarea.scrollHeight);
  }

  render() {
    return (
      <textarea
        name="message"
        rows="1"
        onChange={e => {
          this.autoresize();
          this.props.onChange(e);
        }}
        ref={textarea => {
          this.textarea = textarea;
        }}
      />
    );
  }
}

const StyledForm = styled.form`
  color: ${colors.black};
  font-family: ${fonts.sans};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  margin: 0 auto;
  margin-top: ${spacing[5]};

  ${mediaQueries.medium`
      font-size: ${fontSizes[2]}
      margin-top: ${spacing[6]};
    `};

  * {
    font-size: ${fontSizes[2]};

    ${mediaQueries.medium`
      font-size: calc(${fontSizes[3]} * .9);
    `};
  }

  input,
  textarea {
    border: none;
    -webkit-appearance: none;
    border-bottom: 2px solid ${colors.black};
    border-radius: 0;
    display: block;
    margin-bottom: 4.5rem;
    margin-right: auto;
    margin-left: auto;
    overflow: hidden;
    resize: none;
    width: 100%;
    padding: 0.1em;
    padding-bottom: 0.3em;
    padding-top: 1.5em;

    &:focus {
      outline: none;
    }
  }
  p {
    margin-right: auto;
    margin-left: auto;
    width: 100%;
  }

  button {
    background: none;
    border: 2px solid ${colors.black};
    margin: 0 auto;
    padding: 0.8em 1.6em;
    transition: background-color 0.2s;

    &:hover {
      background: rgba(0, 0, 0, 0.15);
    }

    &:focus,
    &:active {
      outline: none;
    }

    &:active {
      color: white;
      background: ${colors.black};
    }
  }
`;

const InputWrapper = styled.div`
  flex: 1 1 100%;

  ${mediaQueries.medium`
      flex: 0 1 ${props => props.basis ? props.basis : 'auto'};
  `};
`;

const ButtonWrapper = styled.div`
  text-align: center;
  width: 100%;
`;

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state })
    })
      .then(() => alert('Success!'))
      .catch(error => alert(error));

    e.preventDefault();
  };

  render() {
    return (
      <PageWrapper maxWidth={Measures[2]} style={this.props.transition && this.props.transition.style}>
        <Heading>{this.props.data.markdownRemark.frontmatter.title}</Heading>
        <HTMLtoJSX content={this.props.data.markdownRemark.html} />
        <StyledForm
          name="contact"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          <InputWrapper basis={'48%'}>
            <label>
              Name<br />
              <input type="text" name="name" onChange={this.handleChange} />
            </label>
          </InputWrapper>
          <InputWrapper basis={'48%'}>
            <label>
              Email<br />
              <input type="email" name="email" onChange={this.handleChange} />
            </label>
          </InputWrapper>
          <InputWrapper basis={'100%'}>
            <label>
              Message<br />
              <TextArea onChange={this.handleChange} />
            </label>
          </InputWrapper>
          <ButtonWrapper>
            <button type="submit">Send</button>
          </ButtonWrapper>
          <div hidden>
            <label>
              Don’t fill this out: <input name="bot-field" />
            </label>
          </div>
        </StyledForm>
      </PageWrapper>
    );
  }
}

export const contactPageQuery = graphql`
  query ContactPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        title
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/contact-page.js